module.exports = __webpack_public_path__ + "static/media/python.b32ab39f.png";